@if (energyInfo()) {
    <div class="energy-usage-wrapper">
        @if (energyInfo()?.greenHome && hasGreenHomeRole) {
            <div class="green-energy">
                <img class="green-energy-icon" [src]="greenEnergyIconUrl" alt="Grønn bolig" />

                <div class="green-energy-info">
                    <div class="green-energy-title">Grønn bolig</div>
                    <div class="green-energy-text">
                        <div class="green-energy-info-text">{{ energyInfo()?.greenHomeDescription }}. &nbsp;</div>
                        <a href="{{ externalLinksService.getGreenHomeArticleUrl() }}" target="_blank"
                            >Les mer om Grønn bolig<span class="external-link"></span
                        ></a>
                    </div>
                </div>
            </div>
        }

        <div class="energy-usage-info-wrapper">
            @if (!isEstimated()) {
                <div class="column energy-label-column">
                    <div class="header">
                        <div class="title">Energimerke</div>

                        <div class="energy-label-info">
                            @if (energyInfo()?.energyLabel && energyInfo()?.energyLabel !== "ukjent") {
                                <div class="energy-label-descriptor">{{ energyLabelDescription() }}</div>

                                @if (energyInfo()?.energyLabelExpired) {
                                    <div class="energy-label-descriptor">UTGÅTT</div>
                                }

                                @if (energyInfo()?.energyLabelVersion == EnergyLabelVersion.Version2026) {
                                    <div
                                        class="energy-label-icon energy-label26"
                                        [ngClass]="'icon-energy26-' + (energyInfo()?.energyLabel.toLowerCase() || '')"
                                    ></div>
                                } @else {
                                    <div
                                        class="energy-label-icon"
                                        [ngClass]="[energyInfo()?.energyLabelExpired ? 'expired-energy-label' : 'none-expired-energy-label', energyLabelClass()]"
                                    ></div>
                                }
                            } @else {
                                <div class="energy-label-descriptor">Ukjent</div>
                                <div class="energy-label-icon unknown"></div>
                            }
                        </div>
                    </div>

                    <div class="first-section">
                        <div class="keyvalue-pair">
                            <div class="key">Beregnet normert energibruk pr m²/år</div>
                            <div class="value">
                                {{ energyInfo()?.energyLabelEnergyUsagePerSqmPerYear | defaultconvert | thousandize | unit: " kWh" | dash }}
                            </div>
                        </div>
                        <div class="keyvalue-pair">
                            <div class="key">Total energibruk pr år</div>
                            <div class="value">{{ energyInfo()?.energyLabelEnergyUsagePerYear | defaultconvert | thousandize | unit: " kWh" | dash }}</div>
                        </div>
                    </div>

                    <div class="keyvalue-pair">
                        @if (energyInfo()?.energyLabelSource == 5) {
                            <div class="key">Utstedt</div>
                        } @else {
                            <div class="key">Annonsert</div>
                        }

                        <div class="value">{{ energyInfo()?.energyLabelDate | date: "dd.MM.yyyy" | defaultconvert }}</div>
                    </div>

                    <div class="keyvalue-pair">
                        <div class="key">Kilde</div>
                        <div class="value">{{ energyLabelSource() }}</div>
                    </div>

                    <div class="keyvalue-pair">
                        <div class="key__tooltip">
                            Grunnlag
                            <div class="tooltip" (clickOutside)="showBasisTooltip = false">
                                <div class="info-icon" (click)="toggleBasisTooltip()">&nbsp;</div>
                                <div class="tooltip-wrapper">
                                    <ev_tooltip
                                        [visible]="showBasisTooltip"
                                        [left]="25"
                                        [width]="360"
                                        [top]="-118"
                                        [arrowAlignLeft]="-7"
                                        [arrowTopAlign]="110"
                                        arrow="left"
                                        [title]="'Grunnlag'"
                                        (close)="toggleBasisTooltip()"
                                    >
                                        <div class="tooltip-body">
                                            <p>
                                                Energimerke er en teoretisk modell på energieffektiviteten til boligen, og korrektheten er avhengig av hvilken
                                                inndata som er benyttet.
                                            </p>
                                            <br />
                                            <p class="sub-header">Enkel selvregistrering</p>
                                            <p>Begrenset input om bygningens standard og fasiliteter.</p>
                                            <br />
                                            <p class="sub-header">Detaljert selvregistrering</p>
                                            <p>Detaljert input om bygningens standard og fasiliteter.</p>
                                            <br />
                                            <p class="sub-header">Profesjonell energimerking</p>
                                            <p>Utført av ekstern spesialist på området.</p>
                                        </div>
                                    </ev_tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="value">{{ energyInfo()?.energyLabelCertificateMethodName }}</div>
                    </div>

                    <div class="keyvalue-pair">
                        <div class="key">Attestnr</div>
                        @if (energyLabelEnovaNumber()) {
                            <a class="enova-link" href="{{ enovaLink() }}" target="_blank" rel="noopener noreferrer">
                                <div class="value">{{ energyLabelEnovaNumber() }}</div>
                                <div class="external-link"></div>
                            </a>
                        } @else {
                            -
                        }
                    </div>
                </div>

                <div class="column energy-calculation">
                    @if (hasEnergyCalculationRole) {
                        <div class="header">
                            <div class="title">Energiberegning</div>

                            @if (energyInfo()?.energyCalculationDate) {
                                <div class="calculation-date">Beregnet {{ energyInfo()?.energyCalculationDate | date: "dd.MM.yyyy" | defaultconvert }}</div>
                            }
                        </div>

                        <div class="keyvalue-pair">
                            <div class="key">Estimert reelt energibruk pr m²/år</div>
                            <div class="value">
                                {{ energyInfo()?.energyCalculationEnergyUsagePerSqmPerYear | defaultconvert | thousandize | unit: " kWh" | dash }}
                            </div>
                        </div>
                        <div class="keyvalue-pair">
                            <div class="key">Estimert total energibruk pr år</div>
                            <div class="value">
                                {{ energyInfo()?.energyCalculationEnergyUsagePerYear | defaultconvert | thousandize | unit: " kWh" | dash }}
                            </div>
                        </div>
                        <div class="keyvalue-pair">
                            <div class="key">Oppvarming</div>
                            <div class="value">{{ energyInfo()?.energyCalculationHeatingSources | defaultconvert }}</div>
                        </div>
                        <div class="keyvalue-pair">
                            <div class="key">Beboere</div>
                            <div class="value">{{ energyInfo()?.energyCalculationNumberOfResidents | defaultconvert }}</div>
                        </div>
                        <div class="button">
                            <div class="button-items" (click)="onPerformEnergyCalculationClick()">Utfør energiberegning</div>
                        </div>
                    }
                </div>

                <div class="column about">
                    @if (hasEnergyCalculationRole) {
                        <div class="item">
                            <div class="header">
                                <div class="title">Om energibruk</div>
                            </div>
                            <div class="about-text">
                                <p>
                                    Et energimerke er sammenlignbart over hele landet. Beregnet energibruk fra et energimerke vil derfor benytte et normert
                                    klima og en normert bruk av boligen. Eiendomsverdi kjenner ikke til detaljert informasjon som er rapportert inn, og som
                                    benyttes i energiattesten.
                                </p>
                                <p>
                                    Energiberegning tar høyde for klimaforskjeller, antatt bruk av boligen samt de egenskaper og fasiliteter ved boligen, som
                                    Eiendomsverdi har registrert, og som vil påvirke energibruken.
                                </p>
                                <p>Energibruk under energiberegning vil derfor kunne avvike fra energibruk under energimerke.</p>
                            </div>
                        </div>
                    }
                </div>
            }
            @if (isEstimated() && hasEnergyCalculationRole) {
                <div class="column energy-label">
                    <div class="header">
                        <div class="title">Estimert energimerke</div>
                        <div class="energy-label-info">
                            @if (energyInfo()?.energyLabel && energyInfo()?.energyLabel !== "ukjent") {
                                @if (energyInfo()?.energyLabelVersion == EnergyLabelVersion.Version2026) {
                                    <div class="energy-label-descriptor">{{ energyInfo()?.energyLabel }}</div>
                                    <div
                                        class="energy-label-icon energy-label26"
                                        [class]="'icon-energy26-' + (energyInfo()?.energyLabel.toLowerCase() || '')"
                                    ></div>
                                } @else {
                                    <div class="energy-label-descriptor">{{ energyInfo()?.energyLabel + " " + energyLabelColor() }}</div>
                                    <div class="energy-label-icon none-expired-energy-label" [class]="energyLabelClass()"></div>
                                }
                            } @else {
                                <div class="energy-label-descriptor">Ukjent</div>
                                <div class="energy-label-icon unknown"></div>
                            }
                        </div>
                    </div>

                    <div class="first-section">
                        <div class="keyvalue-pair">
                            <div class="key">Beregnet normert energibruk pr m²/år</div>
                            <div class="value">
                                {{ energyInfo()?.energyLabelEnergyUsagePerSqmPerYear | defaultconvert | thousandize | unit: " kWh" | dash }}
                            </div>
                        </div>
                        <div class="keyvalue-pair">
                            <div class="key">Total energibruk pr år</div>
                            <div class="value">{{ energyInfo()?.energyLabelEnergyUsagePerYear | defaultconvert | thousandize | unit: " kWh" | dash }}</div>
                        </div>
                    </div>
                    <div class="keyvalue-pair">
                        <div class="key">Kilde</div>
                        <div class="value">{{ energyLabelSource() }}</div>
                    </div>
                    @if (energyInfo()?.energyCalculationDate) {
                        <div class="keyvalue-pair">
                            <div class="key">Estimert {{ energyInfo()?.energyCalculationDate | date: "dd.MM.yyyy" | defaultconvert }}</div>
                        </div>
                    }
                </div>

                <div class="column energy-calculation">
                    <div class="header">
                        <div class="title">Energiberegning</div>
                        @if (energyInfo()?.energyCalculationDate) {
                            <div class="calculation-date">Beregnet {{ energyInfo()?.energyCalculationDate | date: "dd.MM.yyyy" | defaultconvert }}</div>
                        }
                    </div>
                    <div class="keyvalue-pair">
                        <div class="key">Estimert reelt energibruk pr m²/år</div>
                        <div class="value">
                            {{ energyInfo()?.energyCalculationEnergyUsagePerSqmPerYear | defaultconvert | thousandize | unit: " kWh" | dash }}
                        </div>
                    </div>
                    <div class="keyvalue-pair">
                        <div class="key">Estimert total energibruk pr år</div>
                        <div class="value">{{ energyInfo()?.energyCalculationEnergyUsagePerYear | defaultconvert | thousandize | unit: " kWh" | dash }}</div>
                    </div>
                    <div class="keyvalue-pair">
                        <div class="key">Oppvarming</div>
                        <div class="value">{{ energyInfo()?.energyCalculationHeatingSources | defaultconvert }}</div>
                    </div>
                    <div class="keyvalue-pair">
                        <div class="key">Beboere</div>
                        <div class="value">{{ energyInfo()?.energyCalculationNumberOfResidents | defaultconvert }}</div>
                    </div>
                    <div class="button">
                        <div class="button-items" (click)="onPerformEnergyCalculationClick()">Utfør energiberegning</div>
                    </div>
                </div>
                <div class="column about">
                    <div class="item">
                        <div class="header">
                            <div class="title">Om energibruk</div>
                        </div>
                        <div class="about-text">
                            <p>
                                Et energimerke er sammenlignbart over hele landet. Beregnet energibruk fra et energimerke vil derfor benytte et normert klima og
                                en normert bruk av boligen. Eiendomsverdi kjenner ikke til detaljert informasjon som er rapportert inn, og som benyttes i
                                energiattesten.
                            </p>
                            <p>
                                Energiberegning tar høyde for klimaforskjeller, antatt bruk av boligen samt de egenskaper og fasiliteter ved boligen, som
                                Eiendomsverdi har registrert, og som vil påvirke energibruken.
                            </p>
                            <p>Energibruk under energiberegning vil derfor kunne avvike fra energibruk under energimerke.</p>
                        </div>
                    </div>
                </div>
            }
            @if (isEstimated() && !hasEnergyCalculationRole) {
                <div class="column energy-label">
                    <div class="header">
                        <div class="title">Energimerke</div>
                        <div class="energy-label-info">
                            <div class="energy-label-descriptor">Ukjent</div>
                            <div class="energy-label-icon unknown"></div>
                        </div>
                    </div>
                </div>
                <div class="column"></div>
                <div class="column"></div>
            }
        </div>
    </div>
}
@if (hasEnergyCalculationRole) {
    <div class="accordion-wrapper" [class.expanded]="reportsExpanded">
        <sub-accordion [accordionState]="energyCalculationReportsStateClass">
            <energy-calculation-reports
                [reports]="energyCalculationReportsStateClass.data()"
                [hasGreenHomeRole]="hasGreenHomeRole"
            ></energy-calculation-reports>
        </sub-accordion>
    </div>
}

<div class="accordion-wrapper" [class.expanded]="reportsExpanded">
    <sub-accordion [accordionState]="energyLabelHistoryStateClass">
        <energy-label-history [energyLabelHistory]="energyLabelHistoryStateClass.data()"></energy-label-history>
    </sub-accordion>
</div>
